<template>
  <div :class="['ArchiveThumb', template]" :key="thumbKey">
    <div class="image-container">
      <div
        :class="['image', { active: isBroadcastPlaying, audio: page.audio }]"
      >
        <router-link :to="page.url"
          ><LazyImage
            :image="thumbnail"
            :circle="circle"
            size="medium"
          ></LazyImage
        ></router-link>
        <IconPlayBroadcast
          v-if="page.audio"
          v-bind="page.audio"
          :page-url="page.url"
          :large="true"
        ></IconPlayBroadcast>
      </div>
    </div>
    <aside>
      <router-link :to="page.url">
        <ul v-if="page.template === 'broadcast'" class="bullet-list tags">
          <li v-for="artist in page.artists" :key="artist">
            <span v-html="artist" class="artist-name"></span>
          </li>
        </ul>
        <h3>
          <span
            v-if="page.template === 'event'"
            :class="{ underline: underline }"
            v-html="page.title"
          ></span>
          <span
            v-if="
              page.template === 'broadcast' &&
              page.show &&
              !page.broadcast_alt_name
            "
            :class="{ underline: underline }"
            v-html="page.show['post_title']"
          ></span>
          <span
            v-else-if="page.template === 'broadcast' && page.broadcast_alt_name"
            :class="{ underline: underline }"
            v-html="page.broadcast_alt_name"
          ></span>
          <div v-else-if="page.djs && page.djs.length">
            <a
              v-for="entry in page.djs"
              :href="entry.url"
              class="comma artist-name"
              :key="entry.url"
              >{{ entry.title }}</a
            >
          </div>
          <span
            v-if="page.template === 'show' || page.template === 'dj'"
            v-html="page.title"
          ></span>
          <span
            v-else-if="
              page.template === 'broadcast' &&
              !page.show &&
              !page.guest_session_alt_name
            "
            >guest session</span
          >
          <span
            v-else-if="
              page.template === 'broadcast' &&
              !page.show &&
              page.guest_session_alt_name
            "
            v-html="page.guest_session_alt_name"
          ></span>
          <div v-else-if="page.djs && page.djs.length">
            <a
              v-for="entry in page.djs"
              :href="entry.url"
              class="comma artist-name"
              :key="entry.url"
              >{{ entry.title }}</a
            >
          </div>
          <div
            v-if="page.schedule"
            v-html="page.schedule"
            class="artist-name"
          ></div>
        </h3>
        <div class="event-info" v-if="page.template === 'event'">
          <div>{{ page.formatted.date }}</div>
          <div>{{ page.formatted.time }}</div>
          <div v-html="page.location_name"></div>
        </div>
      </router-link>
      <p v-if="page.broadcast_date" class="date-text">
        {{
          page.broadcast_date.slice(4, 6) +
          "." +
          page.broadcast_date.slice(6, 8) +
          "." +
          page.broadcast_date.slice(2, 4)
        }}
      </p>
      <ul v-if="page.tags" class="bullet-list tags a-hover">
        <li v-for="tag in page.tags" :key="tag.url">
          <router-link
            :to="tag.url"
            v-if="tag.url"
            v-html="tag.name"
          ></router-link>
          <span v-else v-html="tag.name"></span>
        </li>
      </ul>
      <div class="buttons">
        <a
          v-if="page.external_link && isFuture"
          class="pill"
          :href="page.external_link"
        >
          Buy Tickets
        </a>
        <IconAddToCalendar
          :page="page"
          v-if="addToCalendar && isFuture"
          class="pill dashed"
        >
          Add to Calendar
        </IconAddToCalendar>
      </div>
    </aside>
  </div>
</template>

<script>
import IconPlayBroadcast from "./IconPlayBroadcast";
import IconAddToCalendar from "./IconAddToCalendar";
import LazyImage from "./Image";

export default {
  name: "ArchiveThumb",
  components: { IconAddToCalendar, IconPlayBroadcast, LazyImage },
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
    circle: {
      type: Boolean,
      default: false,
    },
    addToCalendar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thumbnail() {
      return this.$store.getters.getThumbnail(this.page);
    },
    thumbKey() {
      return "ArchiveThumb:" + this.page.url;
    },
    isBroadcastPlaying() {
      return (
        this.page.audio &&
        this.page.audio.url &&
        this.$store.state.audio.broadcast.url === this.page.audio.url
      );
    },
    underline() {
      return this.page.template === "show";
    },
    archivePage() {
      return this.page.template === "broadcast";
    },
    template() {
      return this.page.template || "";
    },
    today() {
      return parseInt(new Date().toISOString().split("T")[0].replace(/-/g, ""));
    },
    isFuture() {
      if (!this.page.event_start_date) return false;
      var start = parseInt(this.page.event_start_date.replace(/-/g, ""));
      return start >= this.today;
    },
  },
};
</script>

<style scoped>
.ArchiveThumb {
  display: flex;
  width: 100%;
}

.ArchiveThumb.center {
  align-items: center;
}

h3 {
  word-break: break-word;
}

/* .ArchiveThumb.dj h3, */
.ArchiveThumb.event h3 {
  font: var(--large);
}

.date-text {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  margin-top: 0.4rem;
}

.event-info {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.image-container {
  position: relative;
  margin-right: 2rem;
  width: 30%;
  max-width: 10rem;
  /*width: 7vw;*/
}

.ArchiveThumb.event .image-container {
  max-width: 22rem;
}

.image {
  position: relative;
}

.inactive .image-container {
  display: none;
}

.IconPlayBroadcast {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
}

.ArchiveThumb >>> .IconPlayBroadcast button {
  background-color: #fff;
  height: 100%;
  width: 100%;
}

.image:not(.active) .IconPlayBroadcast {
  display: none;
}

.image.audio:hover .IconPlayBroadcast {
  display: block;
}

.image.audio:hover figure {
  opacity: 0;
}

aside {
  padding: 0;
  margin: 0;
  flex: 1;
}

aside > ul {
  margin-top: 0.5rem;
}

.buttons {
  margin: 1rem -1rem;
  text-align: left;
}

.buttons a {
  margin: 0 1rem 1rem 1rem;
  font: var(--medium);
}

.artist-name {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  margin-bottom: 0.4rem;
}

@media (max-width: 700px) {
  .image-container {
    width: 17.5%;
  }
}
</style>
